import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import useSEO from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({
    title: "404 – Faqja nuk u gjet",
    description: "Faqja që kërkoni nuk ekziston. Kthehuni në faqen kryesore të NaN Studio.",
  });

  return (
    <div className="bg-[#050505] text-white min-h-screen flex flex-col">
      <Nav />

      <main className="flex-1 flex items-center justify-center px-6 py-32">
        <div className="max-w-2xl w-full text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <div className="font-mono-accent text-[11px] uppercase tracking-[0.3em] text-white/40 mb-8">
              Error 404
            </div>

            <h1 className="font-display font-extrabold uppercase leading-[0.85] tracking-tighter text-[8rem] md:text-[12rem] text-white/10 select-none">
              404
            </h1>

            <h2 className="font-display font-extrabold uppercase leading-[0.9] tracking-tighter text-3xl md:text-5xl -mt-6 mb-6">
              Faqja nuk<br />
              <span className="text-[#29ABE2]">u gjet.</span>
            </h2>

            <p className="text-white/50 text-base leading-relaxed mb-12 max-w-md mx-auto">
              Faqja që po kërkoni nuk ekziston ose është zhvendosur.
              Mund të ktheheni në faqen kryesore ose të eksploroni projektet tona.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/"
                className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#29ABE2] text-black font-medium text-sm hover:bg-[#5cc2ec] transition-colors"
              >
                <ArrowLeft size={14} />
                Kthehu në fillim
              </Link>
              <Link
                to="/portfolio"
                className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/[0.15] text-white text-sm hover:bg-white/5 transition-colors"
              >
                Shiko projektet
                <ArrowUpRight size={14} />
              </Link>
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); window.location.href = "/#contact"; }}
                className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/[0.15] text-white text-sm hover:bg-white/5 transition-colors"
              >
                Na kontaktoni
                <ArrowUpRight size={14} />
              </a>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
